type PurchaseOrderSupplierLink = {
  supplier: number;
};

type SupplierPdfSource = {
  id: number;
  name?: string | null;
  address?: string | null;
  phone?: string | null;
};

export const getPurchaseOrderSupplierPdfDefaults = (
  purchaseOrder: PurchaseOrderSupplierLink,
  suppliers?: readonly SupplierPdfSource[],
) => {
  const supplier = suppliers?.find(
    (candidate) => candidate.id === purchaseOrder.supplier,
  );

  return {
    to_company_override: supplier?.name ?? '',
    to_address_override: supplier?.address ?? '',
    phone: supplier?.phone ?? '',
  };
};
